import {ProfileReference} from '@github-ui/profile-reference'
import {BlockedIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'

import {LABELS} from '../constants/labels'
import {createIssueEventExternalUrl} from '../utils/urls'
import type {UserBlockedEventNode} from './issue-viewer-page-query-types'
import {TimelineRow} from './row/TimelineRow'
import styles from './UserBlockedEvent.module.css'

export type UserBlockedEventFragment = Pick<
  UserBlockedEventNode,
  'actor' | 'blockDuration' | 'blockedUser' | 'createdAt' | 'databaseId'
>

type UserBlockedEventProps = {
  queryRef: UserBlockedEventFragment
  issueUrl: string
  onLinkClick?: (event: MouseEvent) => void
  highlightedEventId?: string
  refAttribute?: React.RefObject<HTMLLIElement | null>
}

export function UserBlockedEvent({
  queryRef,
  issueUrl,
  onLinkClick,
  highlightedEventId,
  refAttribute,
}: UserBlockedEventProps): React.ReactElement {
  const {actor, createdAt, blockedUser, blockDuration, databaseId} = queryRef
  const highlighted = String(databaseId) === highlightedEventId
  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
      onLinkClick={onLinkClick}
      leadingIcon={BlockedIcon}
    >
      <TimelineRow.Main>
        <span>{`${blockDuration !== 'PERMANENT' ? `${LABELS.timeline.temporarily} ` : ''} ${
          LABELS.timeline.blocked
        } `}</span>
        <Link href={`/${blockedUser?.login}`} inline className={styles.Link}>
          <ProfileReference login={blockedUser?.login ?? ''} profileName={blockedUser?.name} isAgent={false} />
        </Link>
      </TimelineRow.Main>
    </TimelineRow>
  )
}
